import RegistrationSuccessPanel from "./RegistrationSuccessPanel";

export default RegistrationSuccessPanel;